import type { SampleOrderCardMountData } from '../../../../global_state/src/cardLayersReducer';

// Real sample-order data used to open the sample-order card for local development.
const realSampleOrderCardMountData: SampleOrderCardMountData = {
    brand: { brandName: 'Jack & Jones', brandNumber: '04', isPrimary: false },
    sampleOrder: {
        orderCode: 'SO10278246',
        sampleOrderNumber: 10278246,
        style: {
            styleName: 'APRLOUNGEWEAR SS TEE AND SHORTS SET',
            styleNumber: 12318507,
        },
    },
};

export { realSampleOrderCardMountData };
